import {useWatch} from "react-hook-form";

import {CURRENCY_SYMBOL} from "base/format/config/i18n";
import {NumberUtil} from "base/format/utilities";

import {TotalField} from "base/shared/components";
import {FormInputDecimal} from "base/form/components";

import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";

const PermitExtensionFeesFormFields = ({extension, disabled = false}) => {
    const [felling_price, cutting_price, transport_price, clearing_price] = useWatch({
        name: ["felling_price", "cutting_price", "transport_price", "clearing_price"],
    });

    const disableField = field => {
        return !extension?.types.includes(field); // Field may be in the original permit but not in the extension; in that case we display the field but disable it.
    };

    const hideField = field => {
        return !extension?.permit?.types.includes(field); // If field was not in the original permit we hide it.
    };

    const getTotal = () => {
        const total =
            NumberUtil.parseFloat(felling_price) +
            NumberUtil.parseFloat(cutting_price) +
            NumberUtil.parseFloat(transport_price) +
            NumberUtil.parseFloat(clearing_price);

        if (total) return NumberUtil.formatCurrency(total);

        return 0;
    };

    return (
        <>
            <Stack alignItems="center" pt={1}>
                {hideField("felling") ? null : (
                    <FormInputDecimal
                        name="felling_price"
                        label="Valor pago de abate"
                        endAdornment={CURRENCY_SYMBOL}
                        disabled={disabled || disableField("felling")}
                    />
                )}
                {hideField("cutting") ? null : (
                    <FormInputDecimal
                        name="cutting_price"
                        label="Valor pago de serragem"
                        endAdornment={CURRENCY_SYMBOL}
                        disabled={disabled || disableField("cutting")}
                    />
                )}
                {hideField("transport") ? null : (
                    <FormInputDecimal
                        name="transport_price"
                        label="Valor pago de transporte"
                        endAdornment={CURRENCY_SYMBOL}
                        disabled={disabled || disableField("transport")}
                    />
                )}
                {hideField("clearing") ? null : (
                    <FormInputDecimal
                        name="clearing_price"
                        label="Valor pago de desbravamento"
                        endAdornment={CURRENCY_SYMBOL}
                        disabled={disabled || disableField("clearing")}
                    />
                )}

                <Divider sx={{width: "80%", marginTop: 3}} />
                <TotalField
                    label={"Valor de pagamento total"}
                    total={getTotal()}
                    bold
                />
            </Stack>
        </>
    );
};

export default PermitExtensionFeesFormFields;
